import { combineReducers } from "redux";
import invoiceReducer from "./reducer";

const reducer = combineReducers({
  invoiceReducer,
});

export default reducer;
